import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";

export default {
    storageKey: StorageKey.report_exchange_rate,
    getReportLabel: () => t`Exchange Rates`,
    getColumns: () => [],
};
